export default class Optional<T> {
    private content: T[] = [];
    
    public get value() : T {
        return this.content[0];
    }
    public set value(v : T) {
        // Create a new array with no value or a single value
        if (!v) {
            this.content = [];
        } else {
            this.content = [v]; 
        }
    }

    constructor(initialValue: T) {
        this.value = initialValue;
    }

    WhenEmpty = (action: Function): Optional<T> =>
        this
            .When(() => this.content.length === 0)
            .Then(action());

    Then (action: Function): Optional<T> {
        this.content
            .forEach(value => action(value)); 
        return this;
    }
    
    When = (test: (value: T) => boolean) => new Optional<T>(
        this.content
            .filter(value => test(value))[0]
    );
}
